import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Products from "./components/Products/Products";
import Footer from "./components/Footer/Footer";
import Product from "./components/Product/Product";
import { initialList, allProducts } from "./components/API/ProductsAPI";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutUs from "./components/AboutUs/AboutUs";
import Contact from "./components/Contact/Contact";
import ShoppingCart from "./components/ShoppingChart/ShoppingCart";
import { ALL_PRODUCTS } from "./components/API/ProductsAPI";
import ScrollToTop from "./components/Hooks/useScrollToTop";
import HomePage from "./components/HomePage/HomePage";

function App() {
  const [products, setProducts] = useState(
    initialList.map((id) => allProducts.find((product) => product.id === id))
  );

  const [activeCategory, setActiveCategory] = useState(ALL_PRODUCTS);
  const productsRef = useRef(null);

  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("shoppingCart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const [recentViewedProducts, setRecentViewedProducts] = useState(() => {
    const storedProducts = localStorage.getItem("recentViewedProducts");
    return storedProducts ? JSON.parse(storedProducts) : [];
  });

  useEffect(() => {
    console.log("Cart updated:", cart);
    localStorage.setItem("shoppingCart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    console.log("Recent viwed products updated:", recentViewedProducts);
    localStorage.setItem(
      "recentViewedProducts",
      JSON.stringify(recentViewedProducts)
    );
  }, [recentViewedProducts]);

  const totalQuantity = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header
          products={products}
          setProducts={setProducts}
          setActiveCategory={setActiveCategory}
          nrProducts={totalQuantity}
        />
        <Routes>
          <Route
            path="/shop"
            element={
              <Products
                productsRef={productsRef}
                products={products}
                setProducts={setProducts}
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
                recentViewedProducts={recentViewedProducts}
                setCart={setCart}
              />
            }
          />
          <Route
            path="/product/:productId"
            element={
              <Product
                setCart={setCart}
                recentViewedProducts={recentViewedProducts}
                setRecentViewedProducts={setRecentViewedProducts}
                setProducts={setProducts}
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
              />
            }
          />
          <Route
            path="/"
            element={
              <HomePage
                productsRef={productsRef}
                setProducts={setProducts}
                setActiveCategory={setActiveCategory}
              />
            }
          />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/cart"
            element={<ShoppingCart cart={cart} setCart={setCart} />}
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
